(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('AssessmentQuestionsController', AssessmentQuestionsController);

  /* ngInject */
  function AssessmentQuestionsController(assessmentQuestionService, riskLevels, sessionService) {
    const vm = this;

    vm.refreshAssessmentQuestions = refreshAssessmentQuestions;
    vm.riskCategories = [];
    vm.riskLevel = riskLevels[0].value;
    vm.riskLevels = riskLevels;

    activate();

    function activate() {
      refreshAssessmentQuestions();
    }

    function refreshAssessmentQuestions() {
      assessmentQuestionService(sessionService.getAuthToken()).query({ risk_level: vm.riskLevel }, response => vm.riskCategories = response);
    }
  }
})();
